/**
 * Tournament bracket copy and tuning (specs/champions-league, Story 6).
 */

export const TOURNAMENT_BRACKET_EMPTY_TITLE = 'Bracket not drawn yet';
export const TOURNAMENT_BRACKET_EMPTY_SUBTITLE =
  'Knockout ties appear here once the draw is made.';
export const TOURNAMENT_BRACKET_ERROR_TITLE = "Couldn't load the bracket";
export const TOURNAMENT_BRACKET_RETRY = 'Retry';
export const TOURNAMENT_BRACKET_TEST_IDS = {
  screen: 'tournament-bracket',
  empty: 'tournament-bracket-empty',
  error: 'tournament-bracket-error',
  retry: 'tournament-bracket-retry',
  /** The mirrored tree itself (AC-6.6), which replaced the per-leg card list. */
  tree: 'tournament-bracket-tree',
} as const;
